import lottie from 'lottie-web';
export const lottieAnimations = () => {
  const lottieContainer = document.getElementById('graphic-alignment-container');

  if (lottieContainer) {

    const animation = lottie.loadAnimation({
      container: lottieContainer, // The container element
      renderer: 'svg', // Render type: 'svg', 'canvas', or 'html'
      loop: false, // Set to false for one-time play
      autoplay: false, // Start automatically
      path: '/wp-content/themes/warburg-pincus-wealth-solutions/lib/lottie/alignment.json', // Path to the animation file
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid meet', // Covers the container while preserving aspect ratio
      },
    });

    // Set the playback speed (1 is normal speed, 2 is double speed, etc.)
    //animation.setSpeed(1.4); // Adjust the speed as needed
    // Add a complete event listener
    animation.addEventListener('complete', () => {

    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('is-played')) {
          // Element is in view, play the animation
          animation.play();
          entry.target.classList.add('is-played');
        }
      });
    }, {
      threshold: 0.8 // Trigger when 50% of the element is visible
    });

    observer.observe(lottieContainer);

  }
}